import ID from './ID'

export enum TagType {
  MarketingObjective = 'Marketing Objective',
  Audience = 'Audience',
  Custom = 'Custom',
}

export default class Tag {
  public editing = false
  public editingValues: any

  constructor(
    public id: ID = new ID(),
    public text: string = '',
    public planId: ID = new ID(),
    public isLead: boolean = false,
    public isNested: boolean = false,
    public orderIndex: number = 0,

    public abbreviatedPlanName: string = ''
  ) {
    this.editingValues = {
      name: this.title,
      isLead: this.isLead,
      isNested: this.isNested,
    }
  }

  public get key() {
    return 'tag-' + this.id.intID.toString()
  }

  public get type(): string {
    return this.text?.split(':')?.[0]
  }

  public get title(): string {
    return this.text.substring(this.text.indexOf(':') + 1)
  }

  public get isObjective(): boolean {
    // Matches the current "Marketing Objective:" prefix as well as the legacy
    // "Marketing Objectives:" / "Objective:" prefixes. "objective:" covers both
    // the current and "Objective:" names; the plural needs its own check.
    const lowerText = this.text.toLowerCase()
    return lowerText.indexOf('objective:') > -1 ||
      lowerText.indexOf('marketing objectives:') > -1
      ? true
      : false
  }

  public get isTargetSegment(): boolean {
    // Matches the current "Audience:" prefix as well as the legacy
    // "Target Audience:" / "Target Segment:" / "Target Persona:" prefixes.
    // "Audience" is matched on the exact category name so custom categories
    // like "Primary Audience" aren't picked up.
    const lowerText = this.text.toLowerCase()
    return lowerText.indexOf('target segment:') > -1 ||
      lowerText.indexOf('target persona:') > -1 ||
      lowerText.indexOf('target audience:') > -1 ||
      this.type?.trim().toLowerCase() === 'audience'
      ? true
      : false
  }

  public static fromResponseObject(obj): Tag {
    if (!obj) return new Tag()
    
    return new Tag(
      ID.fromResponseObject(obj.id, 'tags'),
      obj.text,
      ID.fromResponseObject(obj.plan, 'plans'),
      obj.isLead,
      obj.isNested,
      obj.orderIndex
    )
  }

  public forRequestObject() {
    return {
      id: this.id.intID == 0 ? null : this.id.apiID,
      text: this.text,
      plan: this.planId.intID == 0 ? null : this.planId.apiID,
      orderIndex: this.orderIndex,
    }
  }
}
